import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _formatRelativeTimeUn;

import { ShippingDateTypeEnum } from "@temp/@sdk/gqlTypes/globalTypes";
import React from "react";
import { useIntl } from "react-intl";
import { commonMessages } from "../../../../intl";
var formatRelativeTimeUnits = (_formatRelativeTimeUn = {}, _defineProperty(_formatRelativeTimeUn, ShippingDateTypeEnum.DAYS, "days"), _defineProperty(_formatRelativeTimeUn, ShippingDateTypeEnum.WEEKS, "weeks"), _formatRelativeTimeUn);

function EstimatedShipping(_ref) {
  var productType = _ref.productType,
      type = _ref.type,
      exact = _ref.exact;
  var intl = useIntl();
  var shippingMax = productType.shippingMax,
      shippingMin = productType.shippingMin,
      shippingDateType = productType.shippingDateType,
      estimatedShipping = productType.estimatedShipping;
  var estimatedShippingDaysLeft = Math.ceil((Date.now() - Date.parse(estimatedShipping)) / (1000 * 60 * 60 * 24));
  var unit = formatRelativeTimeUnits[shippingDateType || ShippingDateTypeEnum.DAYS];
  var translatedUnit = intl.formatMessage(commonMessages[unit]);
  var messages = {
    long: intl.formatMessage({
      defaultMessage: "Estimated shipping time",
      "id": "@next.components.molecules.EstimatedShipping.EstimatedShipping.3880649852"
    }),
    short: intl.formatMessage({
      defaultMessage: "Est. ship",
      "id": "@next.components.molecules.EstimatedShipping.EstimatedShipping.2772443023"
    })
  };
  var message = messages[type];

  if (exact && estimatedShipping) {
    /* tslint:disable:object-literal-sort-keys */
    return React.createElement(React.Fragment, null, "".concat(message, " ").concat(intl.formatDate(estimatedShipping, {
      month: "short",
      day: "numeric"
    })));
    /* tslint:enable:object-literal-sort-keys */
  }

  if (shippingMax && shippingMin) {
    return React.createElement(React.Fragment, null, "".concat(message, " ").concat(intl.formatMessage(commonMessages.from), " ").concat(shippingMin, " ").concat(intl.formatMessage(commonMessages.to), " ").concat(shippingMax, " ").concat(translatedUnit));
  }

  if (estimatedShipping) {
    return React.createElement(React.Fragment, null, "".concat(message, " ").concat(intl.formatRelativeTime(estimatedShippingDaysLeft, unit)));
  }

  return React.createElement(React.Fragment, null);
}

export { EstimatedShipping };